// extracted by mini-css-extract-plugin
module.exports = {"intro":"Home_intro__1TGNR","introBox":"Home_introBox__1lkmJ","header":"Home_header__2ep7R","subheader":"Home_subheader__18uIZ"};